var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-group",class:{ noBorder: _vm.noBorder }},_vm._l((_vm.options.items),function(item,index){return _c('btn',{key:index,attrs:{"options":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }